<template>
     <div class="default-error-page" :class="{'ac-bg-gray': ac}">
        <header-component 
            :is-soon="false" 
            img-left="/trocachip/img/setinha-left-preto.svg" 
            img-right="/trocachip/img/access.png" 
            class="header-component"
            :backRoute="false"
        />
        
        <div class="default-error-page-content">
			<img src="../assets/images/ic_error.svg" alt="error" title="error" />
			<strong v-html="title"></strong>

			<span v-html="description"></span>
            <button class="btn btn-primary" :class="{'ac-color-black': ac, 'ac-border-yellow': ac, 'ac-bg-yellow': ac}" @click.prevent="callAction">
                {{actionLabel}}
            </button>
		</div>
     </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent";
import {mapState} from "vuex";

export default {
    name: "DefaultError",
    components: {
        HeaderComponent,
    },
    props: {
        title: { type: String, default: "Não foi possível realizar a troca do seu chip" },
        description: { type: String, default: "Tente novamente mais tarde!" },
        actionLabel: { type: String, default: "Tente novamente" },
        action: { type: Function }
    },
    created() {
    if (this.disableBack) {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };
    }
    },
    computed: {
        ...mapState({
            ac: state => state.ac,
            customer: state => state.customer,
            config: state => state.config,
            eligibilityErrorsCount: state => state.eligibilityErrorsCount,
            disableBack: state => state.disableBack
        })
    },
    methods: {
        callAction() {
            if (this.action) {
                this.action();
            } else {
                window.location.replace(this.config.returnURL);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.default-error-page {
	width: 100vw;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
}

.default-error-page-content {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	font-family: 'timsans_regular';
	text-align: center;
}

.default-error-page-content strong {
	font-size: 32px;
	font-weight: 300;
	margin-top: 37px;
    width: 75%;
}

.default-error-page-content span {
	margin-top: 27px;
	opacity: 0.6;
	font-size: 16px;
	color: #000000;
    width: 75%;
}

button {
    margin-top: 40px;
    width: 286px;
}

</style>